import Projects from './Index'
import ProjectsView from './View'

export default [
  {
    path: '/projects',
    name: 'projects',
    component: Projects,
    meta: {
      auth: true,
      permission: 'view',
    },
  },
  {
    path: '/projects/:id',
    name: 'projectsView',
    component: ProjectsView,
    meta: {
      auth: true,
      permission: 'view',
    },
  },
]
